import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from './DefaultModal';

const CHAR_LIMITS = {
  objeto: 500,
};

function DemandaModal({ show, onClose, onSuccess, demandaData = null }) {
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const [formData, setFormData] = useState({
    cnpj: '',
    num: '',
    dataCriacao: '',
    objeto: '',
    tipo: '',
    usuario: '',
    anoBase: '',
    agrupamento: '',
  });

  useEffect(() => {
    if (show) {
      if (demandaData) {
        setFormData(demandaData);
      } else {
        // Reset form quando for nova demanda
        setFormData({
          cnpj: localStorage.getItem('cnpj') || '',
          num: '',
          dataCriacao: '',
          objeto: '',
          tipo: '',
          usuario: '',
          anoBase: localStorage.getItem('anoBase') || '',
          agrupamento: '',
        });
      }
    } else {
      // Limpa o formulário quando o modal é fechado
      setFormData({
        cnpj: '',
        num: '',
        dataCriacao: '',
        objeto: '',
        tipo: '',
        usuario: '',
        anoBase: '',
        agrupamento: '',
      });
    }
  }, [demandaData, show]);

  function handleChange(event) {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  }

  function handleSubmit(event) {
    event.preventDefault();
    
    const updatedTramitacao =
      !formData.tramitacao ||
      formData.tramitacao === '' ||
      formData.tramitacao === null
        ? 'EM ELABORAÇÃO'
        : formData.tramitacao === 'DEVOLVIDO PARA CORREÇÃO'
        ? 'EM CORREÇÃO'
        : formData.tramitacao;

    const cnpj = formData.cnpj || localStorage.getItem('cnpj');
    const updatedFormData = {
      ...formData,
      cnpj,
      tramitacao: updatedTramitacao,
      anoBase: localStorage.getItem('anoBase'),
    };

    // Validação do ano da Data da Contratação
    const anoBaseSelecionado = parseInt(localStorage.getItem('anoBase'));
    let anoDataContratacao;
    if (formData.dataConclusao && typeof formData.dataConclusao === 'string') {
      anoDataContratacao = parseInt(formData.dataConclusao.split('-')[0]);
      if (anoDataContratacao !== anoBaseSelecionado) {
        showDefaultModal(
          'error',
          `O ano da Data da Contratação (${anoDataContratacao}) deve ser igual ao Ano Base selecionado (${anoBaseSelecionado}).\nAtualize a data ou troque o Ano Base.`
        );
        return;
      }
    }

    axios
      .post(`${API_BASE_URL.DEMANDA}/save`, updatedFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        showDefaultModal('success', 'O registro foi salvo com sucesso!', () => {
          if (onSuccess) {
            onSuccess();
          }
          onClose();
        });
      })
      .catch(error => {
        console.error('Erro ao salvar demanda:', error);
        showDefaultModal(
          'error',
          'Erro ao salvar o registro. Tente novamente.' + error
        );
      });
  }

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div 
          className="modal-dialog modal-dialog-centered"
        //   style={{ maxWidth: '70vw' }}
        >
          <div className="modal-content" style={{ borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(19, 72, 156) 0%, rgba(19, 72, 156, 1) 100%)',
                padding: '0.35rem 0.75rem',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                  <i className="bi bi-file-earmark-text me-2" />
                  {demandaData ? 'Editar Demanda' : 'Cadastro de Demanda'}
                </h6>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-link text-white p-0 mb-0"
                    onClick={onClose}
                    title="Fechar"
                    style={{ fontSize: '1rem', textDecoration: 'none' }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body small">
              <form id="demandaModalForm" className="small" onSubmit={handleSubmit}>
                <div className="row g-2">
                  <div className="col-md-4 col-sm-6">
                    <label className="form-label fw-semibold mb-1">
                      Data de Criação
                    </label>
                    <input
                      onChange={handleChange}
                      value={formData.dataCriacao}
                      name="dataCriacao"
                      type="date"
                      id="dataCriacao"
                      className="form-control form-control-sm"
                    />
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <label className="form-label fw-semibold mb-1">Tipo</label>
                    <select
                      className="form-select form-select-sm"
                      value={formData.tipo}
                      onChange={handleChange}
                      name="tipo"
                      id="tipo"
                      required
                    >
                      <option value="">Selecione...</option>
                      <option value="MATERIAL">MATERIAL</option>
                      <option value="OBRA">OBRA</option>
                      <option value="SERVIÇO">SERVIÇO</option>
                      <option value="SERVIÇO DE ENGENHARIA">
                        SERVIÇO DE ENGENHARIA
                      </option>
                    </select>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <label className="form-label fw-semibold mb-1">
                      Agrupamento
                    </label>
                    <select
                      className="form-select form-select-sm"
                      value={formData.agrupamento}
                      onChange={handleChange}
                      name="agrupamento"
                      id="agrupamento"
                      required
                    >
                      <option value="">Selecione...</option>
                      <option value="ITEM">ITEM</option>
                      <option value="LOTE">LOTE</option>
                    </select>
                  </div>
                </div>
                <div className="row g-2 mt-2">
                  <div className="col-12">
                    <label className="form-label fw-semibold mb-1">
                      Descrição do Objeto
                    </label>
                    <textarea
                      className="form-control form-control-sm"
                      rows="3"
                      value={formData.objeto}
                      name="objeto"
                      onChange={handleChange}
                      maxLength={CHAR_LIMITS.objeto}
                      style={{ resize: 'vertical' }}
                      placeholder="Descreva detalhadamente o objeto da contratação..."
                      required
                    />
                    <small className="text-muted">
                      {formData.objeto?.length || 0}/{CHAR_LIMITS.objeto} caracteres
                    </small>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={onClose}
              >
                Cancelar
              </button>
              <button
                type="submit"
                form="demandaModalForm"
                className="btn btn-success btn-sm"
              >
                <i className="bi bi-check-lg me-1" />
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default DemandaModal;
